import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { connect, ReactReduxContext } from 'react-redux';
import { NoLocationModal } from './NoLocationModal';
import { locationDuck } from '../../ducks/location';
var locationOperations = locationDuck.operations;

var LocationSelection = /*#__PURE__*/function (_Component) {
  _inherits(LocationSelection, _Component);

  var _super = _createSuper(LocationSelection);

  function LocationSelection(props) {
    _classCallCheck(this, LocationSelection);

    return _super.call(this, props);
  }

  _createClass(LocationSelection, [{
    key: "render",
    value: function render() {
      var _this = this;

      return /*#__PURE__*/React.createElement(ReactReduxContext.Consumer, null, function (context) {
        return /*#__PURE__*/React.createElement(NoLocationModal, {
          results: _this.props.results,
          store: _this.props.store,
          additionalResults: _this.props.additionalResults,
          toggleChangeModal: _this.props.toggleChangeNoLocationModal,
          noLocationShow: _this.props.changeNoLocationModal,
          setUserModified: _this.props.setUserModified,
          location: _this.props.location
        });
      }.bind(this));
    }
  }]);

  return LocationSelection;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    location: state.location.location,
    results: state.location.results,
    additionalResults: state.location.additionalResults,
    changeNoLocationModal: state.location.changeNoLocationModal
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    toggleChangeNoLocationModal: function toggleChangeNoLocationModal(active) {
      return dispatch(locationOperations.toggleChangeNoLocationModal(active));
    },
    setUserModified: function setUserModified(modified) {
      return dispatch(locationOperations.setUserModified(modified));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LocationSelection);